import { safeString } from '@exodus/safe-string';
const REASON_PATTERNS = [
    { pattern: /unable to validate order/iu, hint: safeString `Order validation failed` },
    { pattern: /could not create the order/iu, hint: safeString `Order creation failed` },
    { pattern: /no rate available/iu, hint: safeString `No rate available` },
    { pattern: /transfer amount exceeds balance/iu, hint: safeString `Transfer exceeds balance` },
    {
        pattern: /insufficient funds|not enough (funds|lovelace)/iu,
        hint: safeString `Insufficient funds`,
    },
    { pattern: /execution reverted/iu, hint: safeString `Transaction would revert` },
    { pattern: /\breverted\b/iu, hint: safeString `Reverted` },
    { pattern: /nonce too low/iu, hint: safeString `Nonce too low` },
    { pattern: /invalid nonce/iu, hint: safeString `Invalid nonce` },
    { pattern: /invalid opcode/iu, hint: safeString `Invalid opcode` },
    {
        pattern: /replacement transaction underpriced/iu,
        hint: safeString `Replacement transaction underpriced`,
    },
    { pattern: /not a valid method ID/iu, hint: safeString `Invalid method ID` },
    { pattern: /multicall3:\s*call failed/iu, hint: safeString `Multicall failed` },
    { pattern: /custom program error: 0x/iu, hint: safeString `Solana program error` },
    { pattern: /sig(nature)? error|SIGERROR/iu, hint: safeString `Signature error` },
    {
        pattern: /cannot locally simulate batched/iu,
        hint: safeString `Cannot locally simulate batched transactions`,
    },
    { pattern: /(txn-)?mempool-conflict/iu, hint: safeString `Mempool conflict` },
    { pattern: /locked too many accounts/iu, hint: safeString `Too many accounts` },
    { pattern: /simulation API call failed/iu, hint: safeString `Simulation API call failed` },
    { pattern: /failed to simulate/iu, hint: safeString `Simulation failed` },
    { pattern: /network request failed|failed to fetch/iu, hint: safeString `Network request failed` },
    { pattern: /rpc timeout/iu, hint: safeString `RPC timeout` },
    { pattern: /timeout|etimedout/iu, hint: safeString `Timeout` },
    { pattern: /econnrefused|econnreset/iu, hint: safeString `Connection failed` },
    { pattern: /api request limit exceeded|rate.?limit/iu, hint: safeString `Rate limited` },
    { pattern: /bad request/iu, hint: safeString `Bad request` },
    {
        pattern: /response\.clone has been disabled/iu,
        hint: safeString `React Native memory pressure`,
    },
    { pattern: /number-unit\.(sub|add) on different/iu, hint: safeString `Number unit mismatch` },
    { pattern: /inputs.*missing|missing.*inputs/iu, hint: safeString `Inputs missing` },
    { pattern: /user (refused|cancelled)/iu, hint: safeString `User cancelled` },
    { pattern: /old-consensus-branch-id/iu, hint: safeString `Old consensus branch` },
];
export function classifyExchangeError(message) {
    if (!message)
        return undefined;
    return REASON_PATTERNS.find(({ pattern }) => pattern.test(message))?.hint;
}
